// extracted by mini-css-extract-plugin
export default {"attendance-report__container":"styles_attendance-report__container__CHK2G"};